// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

import { Link as RouterLink } from 'react-router-dom';
import aboutus from 'assets/csdd_images/whowearepic.jpg';

const WhoWeAre = () => {
  return (
    <MKBox component='section' py={{ xs: 3, md: 12 }}>
      <Container>
        <Grid container alignItems='center'>
          <Grid item xs={12} lg={5}>
            <MKTypography variant='h2' my={1} textGradient>
              Who We Are
            </MKTypography>
            <MKTypography
              textAlign='justify'
              lineHeight={1.7}
              variant='body2'
              color='text'
              mb={2}
            >
              The Chamber of Suppliers Development and Diversity-Africa
              (CSDD-Africa) is the leading representative body for suppliers,
              particularly micro, small, and medium enterprises (MSMEs). Our
              organization is committed to facilitating the growth of MSMEs and
              promoting diversity and inclusion within the procurement and
              supply chain sectors across Africa. We prioritize fostering
              fairness, transparency, and excellence in all procurement and
              supply chain activities throughout the continent.
              <br />
              <br />
              The (CSDD) serves as a dedicated research and development entity
              within the industry, focused on improving the overall viability of
              its members while promoting the sustainability of Global
              Procurement and Supply Chain Management practices. Through its
              initiatives, the CSDD aims to facilitate advancements that not
              only enhance operational efficiency but also support long-term
              sustainable strategies within the supply chain ecosystem.
            </MKTypography>
            <MKTypography
              component={RouterLink}
              to='/about-us'
              variant='body2'
              color='error'
              fontWeight='regular'
              sx={{
                width: 'max-content',
                display: 'flex',
                alignItems: 'center',

                '& .material-icons-round': {
                  fontSize: '1.125rem',
                  transform: 'translateX(3px)',
                  transition:
                    'transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)',
                },

                '&:hover .material-icons-round, &:focus .material-icons-round':
                  {
                    transform: 'translateX(6px)',
                  },
              }}
            >
              More about us
              <Icon sx={{ fontWeight: 'bold' }}>arrow_forward</Icon>
            </MKTypography>
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              textAlign: 'center',
              ml: { xs: -2, lg: 'auto' },
              mt: { xs: 6, lg: 0 },
            }}
          >
            <img
              style={{
                borderRadius: '10px',
                height: '90%',
                width: '90%',
                objectFit: 'contain',
              }}
              src={aboutus}
              alt='Training session by CSDD'
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
};

export default WhoWeAre;
